import { useCallback, } from 'react';
import { connect } from 'react-redux';

import { PROMO_CODE_DELETE, SET_DELETE_PROMO_CODE_DIALOGUE_OPEN, ShareScheduleCode,  } from '../actions/types';
import { siteboardAction, } from '../actions/defaultActions';
import PopupWindow from './PopupWindow';
import PushButton from './PushButton';

const DeletePromoCodeDialogue = ({ _promoCodes, _deletePromoCodeDialoguePromoCodeId, siteboardAction }) => {
  const closeDialogue = useCallback(() => {
    siteboardAction(SET_DELETE_PROMO_CODE_DIALOGUE_OPEN, { isOpen: false, promoCodeId: '', });
  }, [siteboardAction]);

  const selectedPromoCode = _promoCodes[_deletePromoCodeDialoguePromoCodeId];
  if(selectedPromoCode === undefined) return (<></>);

  return (
    <PopupWindow title='Delete Promo Code' closeDialogue={closeDialogue} bgStyle='bg-[#333]'>
      <div className='max-w-[400px] bg-[#333] text-white'>
        <div className='w-[400px]' />
        <div className='py-2'>
          Delete code <b>{ShareScheduleCode.truncate(selectedPromoCode.code)}</b>? 
        </div>
        <div className='flex mt-4'>
          <PushButton 
            textColor='white'
            bgColor='bg-red-800'
            hoverBgColor='bg-red-600'
            onClick={() => {
              const onSuccess = () => {
                closeDialogue();
              };
              siteboardAction(PROMO_CODE_DELETE, { code: selectedPromoCode.code }, onSuccess);
            }}
          >
            Delete Code
          </PushButton>
        </div>
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _promoCodes: state.serverSynced.promoCodes,
  _deletePromoCodeDialoguePromoCodeId: state.localEphemeral.deletePromoCodeDialoguePromoCodeId,
}};
export default connect(mapStateToProps, { siteboardAction })(DeletePromoCodeDialogue);
